import React, { useState, useEffect } from 'react';
import '../style.scss';
import H3FormInput from '@Uilib/h3FormInput';
import { Alert, DatePicker, Select } from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import dayjs from 'dayjs';
import { toISTDate } from '@Apis/constants';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InventoryLocationActions from '@Actions/settings/inventoryLocationActions';
import StockMasterActions from '@Actions/inventory/stockMasterActions';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const BulkUpdateBatchForm = ({
  batches, updateBatchesLoading, getInventoryLocationsLoading, inventoryLocations, getInventoryLocations, sourceTenantDepartmentId, tenantId, callback, updateBatch, user,
}) => {
  const enabledWarehouseLocations = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
  const [updatedLotNumber, setUpdatedLotNumber] = useState('');
  const [updatedBatchQuality, setUpdatedBatchQuality] = useState('');
  const [updatedExpiryDate, setUpdatedExpiryDate] = useState('');
  const [selectedInventoryLocation, setSelectedInventoryLocation] = useState(null);
  const [selectedInventoryLocationName, setSelectedInventoryLocationName] = useState('');

  useEffect(() => {
    getInventoryLocations(sourceTenantDepartmentId || '', '', null, true, tenantId);
  }, []);

  function updateObjects(arr) {
    return arr.map((obj) => {
      const tempPayload = {
        batch_id: obj.batch_id,
        lot_number: updatedLotNumber,
        is_rejected_batch: updatedBatchQuality,
        inventory_location_id: selectedInventoryLocation || obj.inventory_location_id,
        expiry_date: obj.expiry_days === -1 ? obj.expiry_date : toISTDate(updatedExpiryDate),
      };
      if (updatedBatchQuality === '') { delete tempPayload.is_rejected_batch; }
      if (updatedLotNumber === '') { delete tempPayload.lot_number; }
      if (updatedExpiryDate === '') { delete tempPayload.expiry_date; }
      if (!enabledWarehouseLocations) { delete tempPayload.inventory_location_id; }
      return tempPayload;
    });
  }

  // eslint-disable-next-line prefer-const

  return (
    <div className="header__filter__container-inventory-lookup">

      <div className="filter__container filter__container-section" style={{ marginTop: '55px' }}>

        <div className="filter__title"> Lot Number </div>
        <H3FormInput
          disabled={updateBatchesLoading}
          labelClassName="orgFormLabel"
          inputClassName="orgFormInput"
          value={updatedLotNumber}
          onChange={(e) => setUpdatedLotNumber(e.target.value)}
        />
      </div>
      <div className="filter__container filter__container-section">
        <div className="filter__title">Batch Quality </div>
        <PRZSelect
          value={updatedBatchQuality}
          onChange={(value) => { setUpdatedBatchQuality(value); }}
          disabled={!user?.tenant_info?.permission?.allow_to_change_product_batches_quality || updateBatchesLoading}
        >
          <Option key={0} value={false}>
            Good
          </Option>
          <Option key={1} value>
            Bad
          </Option>
        </PRZSelect>
      </div>
      <div className="filter__container filter__container-section">
        <div className="filter__title"> Expiry Date </div>
        <DatePicker
          // disabledDate={(current) => dayjs().add(-1, 'month') >= current}
          value={updatedExpiryDate}
          onChange={(value) => {
            setUpdatedExpiryDate(value);
          }}
          disabled={updateBatchesLoading}
          style={{
            border: '1px solid rgba(68, 130, 218, 0.2)',
            borderRadius: '2px',
            minHeight: '28px',
            width: '100%',
            fontSize: '13px',
          }}
        />
      </div>
      <Alert
        message="If a product is non perishable it wont update the expiry date in that case."
        banner
        closable={false}
      />
      {enabledWarehouseLocations && (
        <div className="filter__container filter__container-section" style={{ marginTop: '15px' }}>
          <div className="filter__title"> Warehouse Bin </div>
          <PRZSelect
            value={selectedInventoryLocationName}
            loading={getInventoryLocationsLoading}
            disabled={updateBatchesLoading}
            filterOption={false}
            showSearch
            onChange={(value) => {
              setSelectedInventoryLocation(value);
              setSelectedInventoryLocationName(inventoryLocations?.inventory_location?.find((item) => item.inventory_location_id == value)?.inventory_location_path);
            }}
            onSearch={(keyword) => {
              getInventoryLocations(sourceTenantDepartmentId || '', keyword, null, true, tenantId);
            }}
          >
            {
                    inventoryLocations?.inventory_location?.filter((item) => item?.is_active)?.map((item) => (
                      <Option
                        key={item?.inventory_location_id}
                        value={item?.inventory_location_id}
                      >
                        <H3Text text={item?.inventory_location_path} className="create-new-batch__location-item" />
                      </Option>
                    ))
            }
          </PRZSelect>
        </div>
      )}
      <div className="create-multi-batch-update__footer">
        <H3Button
          text="Update Batches"
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          customClass="create-multi-batch-update__footer-submit"
          onClick={() => {
            const payload = updateObjects(batches);
            updateBatch(payload, () => {
              callback();
            });
          }}
        />
      </div>
    </div>
  );
};
const mapStateToProps = ({
  StockMasterReducers, InventoryLocationReducers,
}) => ({
  updateBatchesLoading: StockMasterReducers.updateBatchesLoading,
  inventoryLocations: InventoryLocationReducers.inventoryLocations,
  getInventoryLocationsLoading: InventoryLocationReducers.getInventoryLocationsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateBatch: (payload, callback) => dispatch(StockMasterActions.updateBatches(payload, callback)),
  getInventoryLocations: (tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId) => dispatch(InventoryLocationActions.getInventoryLocations(tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId)),
});

BulkUpdateBatchForm.propTypes = {
  tenantId: PropTypes.any,
  updateBatch: PropTypes.func,
  sourceTenantDepartmentId: PropTypes.any,
  batches: PropTypes.any,
  updateBatchesLoading: PropTypes.bool,
  inventoryLocations: PropTypes.any,
  getInventoryLocations: PropTypes.func,
  getInventoryLocationsLoading: PropTypes.bool,
  callback: PropTypes.func,
  user: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkUpdateBatchForm));
